import { render } from "./AgentWhatsAppView.vue?vue&type=template&id=1477f07e&scoped=true"
import script from "./AgentWhatsAppView.vue?vue&type=script&lang=js"
export * from "./AgentWhatsAppView.vue?vue&type=script&lang=js"

import "./AgentWhatsAppView.vue?vue&type=style&index=0&id=1477f07e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1477f07e"]])

export default __exports__